
<p-drawer [(visible)]="showSideBar" position="right" styleClass="cp-drawer">
  <div class="cp-drawer-header text-center">
    <div class="col text-left">
      <h5 class="cp-drawer-title">{{sidebarTitle}}</h5>
    </div>
    <div class="d-flex justify-content-start" class="notificationtype-div">
      <label>
        <strong>Notification Type</strong>
      </label>
      <p-select style="flex: 1;" name="notificationTypes" [options]="filteredNotificationTypes" optionValue="notificationTypeId"
        placeholder="Select a Notification Type" optionLabel="notificationTypeName" class="pl-2"
        [(ngModel)]="selectedNotificationTypeId" (onChange)="loadNotification()" [disabled]="notificationId > 0" />
    </div>
  </div>

  @switch(selectedNotificationTypeId) {
    @case (NotificationTypeEnum.ChangeOrder) {
      <changeorder-notifications #NotificationComp
      (complete)="getCloseStatus($event)" />
    }
    @case (NotificationTypeEnum.Recordables) {
      <recordable-notifications #NotificationComp
      (complete)="getCloseStatus($event)" />
    }
  }
    
  @if (!selectedNotificationTypeId) {
    <div class="cp-drawer-body" >
    </div>
  }
  @if (!selectedNotificationTypeId) {
    <div class="cp-drawer-footer">
      <!--#region SideBar Buttons  -->
      @if (!selectedNotificationTypeId) {
        <div>
          <pcp-commandbar>
            <command-button button-left [text]="ButtonText.Close" [iconClasses]="['fas fa-window-close']"
              (commandClick)="getCloseStatus(false)" />
          </pcp-commandbar>
        </div>
      }
      <!--#endregion -->
    </div>
  }
</p-drawer>
@if (showSideBar) {
  <div class="sidebar-mask"></div>
}
